import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: 10,
    backgroundColor: '#e0e0e0',
    height: '100%',
    color: '#606060',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column'
  },
  dashText: {
    fontSize: 20,
    fontWeight: 'bold',
    marginLeft: 8
  },
  dashDate: {
    fontSize: 60,
    fontWeight: 'bold',
    marginLeft: 8
  },
  dashDateRange: {
    fontSize: 50,
    fontWeight: 'bold',
    marginLeft: 8,
    height: '100%',

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 170
  }
}))

export default useStyles
